import {getLogger} from "@prosay/logging"
import {useEffect} from "react"
import {
    PendingCaseDocument,
    PendingCaseSubscription,
    PendingCaseSubscriptionVariables,
    useGetPendingCasesQuery,
} from "../graphql"

const logger = getLogger(__filename)

export const useGetPendingCases = logger.debug(
    (...hookParams: Parameters<typeof useGetPendingCasesQuery>) => {
        const query = useGetPendingCasesQuery(...hookParams)
        useEffect(() => {
            const unsubscribe = query.subscribeToMore<
                PendingCaseSubscription,
                PendingCaseSubscriptionVariables
            >({
                document: PendingCaseDocument,
                onError: error => {
                    logger.error`Got the following error in useGetPendingCases::onError: ${error}`
                },
                updateQuery: (previous, {subscriptionData: {data}}) => {
                    if (!data.pendingCase || !data.pendingCase.pendingCase) {
                        return previous
                    }
                    return {
                        ...previous,
                        getPendingCases: [
                            data.pendingCase.pendingCase,
                            ...(previous.getPendingCases ?? []),
                        ],
                    }
                },
                variables: {},
            })
            return unsubscribe
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
        return query
    },
    "useGetPendingCases",
)
